import{gql as e}from"@apollo/client";const o=e`
  mutation deleteUserProfileImage {
    asset {
      deleteUserProfileImage
    }
  }
`;export{o as DELETE_USER_PROFILE_PICTURE};
//# sourceMappingURL=useDeleteProfilePicture.graphql.js.map
